import React, { Suspense } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import PageSeo from "./seo/PageSeo";
import AppRoutes from "./AppRoutes";
import Layout from "./components/Layout";
import RouteBoundary, { RouteLoading } from "./components/RouteBoundary";

const App = () => {
  const { pathname } = useLocation();

  return (
    <Layout>
      <PageSeo />
      <RouteBoundary key={pathname}>
        <Suspense fallback={<RouteLoading />}>
          <Routes>
            {AppRoutes.map((route, index) => {
              const { element, ...rest } = route;
              return <Route key={index} {...rest} element={element} />;
            })}
          </Routes>
        </Suspense>
      </RouteBoundary>
    </Layout>
  );
};

export default App;
